



































































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import VLazyImage from 'v-lazy-image';
import Swiper from '@/components/Swiper';


@Component({
  name: 'Carousel3D',
  components: {
    Swiper,
    VLazyImage,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    titleBlock: {
      type: String,
      default: '',
    },
    slides: {
      type: Array,
      default: () => [],
    },
    withoutNumbers: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      leftEnd: true,
      rightEnd: false,
      swiperOption: {
        navigation: false,
        effect: 'fade',
        height: 500,
        loop: false,
        pagination: {clicked: true},
      },
      sliderTitleLeft: 100,
    };
  },
  mounted() {
    this.$watch('$refs.swiper.leftEnd', (value) => this.leftEnd = value, {immediate: true});
    this.$watch('$refs.swiper.rightEnd', (value) => this.rightEnd = value, {immediate: true});
  },
  methods: {
    slidePrev() {
      if (!!this.$refs && !!this.$refs.swiper && !this.leftEnd) {
        (this.$refs.swiper as Swiper).slidePrev();
      }
    },
    slideNext() {
      if (!!this.$refs && !!this.$refs.swiper && !this.rightEnd) {
        (this.$refs.swiper as Swiper).slideNext();
      }
    },
    formatNumber(num) {
      return (num < 10) ? '0' + num.toString() : num.toString();
    },
  },
})
export default class Carousel3D extends Vue {}
